import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchProject, updateProject } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ProjectEditPage() {
  const { businessDomainId, businessUnitId, projectId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const basePath = `/strategy/${businessDomainId}/business-units/${businessUnitId}/projects/${projectId}`;

  const [original, setOriginal] = useState(null);
  const [form, setForm] = useState({ projectName: "", projectDescription: "", startDate: "", endDate: "" });

  useEffect(() => {
    (async () => {
      try {
        const d = await fetchProject(projectId);
        if (!d) return;
        setOriginal(d);
        setForm({
          projectName: d.projectName || "",
          projectDescription: d.projectDescription || "",
          startDate: d.startDate ? d.startDate.substring(0, 10) : "",
          endDate: d.endDate ? d.endDate.substring(0, 10) : "",
        });
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateProject({
        ...original,
        projectName: form.projectName,
        projectDescription: form.projectDescription,
        startDate: form.startDate ? `${form.startDate}T00:00:00.000Z` : null,
        endDate: form.endDate ? `${form.endDate}T00:00:00.000Z` : null,
      });
      notify.success(t("message.update.success"));
      navigate(basePath);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("project.edit.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField fullWidth required label={t("project.name")} name="projectName"
              value={form.projectName} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth multiline rows={3} label={t("project.description")} name="projectDescription"
              value={form.projectDescription} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth type="date" label={t("project.startDate")} name="startDate"
              value={form.startDate} onChange={handleChange} slotProps={{ inputLabel: { shrink: true } }} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth type="date" label={t("project.endDate")} name="endDate"
              value={form.endDate} onChange={handleChange} slotProps={{ inputLabel: { shrink: true } }} />
          </Grid>
          {original?.successFactorName && (
            <Grid size={12}>
              <TextField
                fullWidth
                disabled
                label={t("successFactor.name")}
                value={original.successFactorName}
                slotProps={{ input: { style: { color: "rgba(0,0,0,0.87)" } } }}
              />
            </Grid>
          )}
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/projects/${projectId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
